import { Plane } from "@react-three/drei";
import useThreeJsLoader from "../../../zustand/stores/useThreeJsLoader";
import { useEffect, useRef, useState } from "react";
import MoldingsManager from "./MoldingsManager";
import * as THREE from "three";

const AnimatedPainting = (props) => {
  const gifRef = useRef();

  // const handleVideoSize = (e) => {
  //   console.log(
  //     "gifRef =>",
  //     gifRef.current.videoHeight,
  //     gifRef.current.videoWidth
  //   );
  // };

  const [video] = useState(() => {
    const vid = document.createElement("video");
    vid.src = props.imgUrl;
    gifRef.current = vid;
    // vid.addEventListener("loadedmetadata", handleVideoSize, false);
    vid.crossOrigin = "Anonymous";
    vid.loop = true;
    vid.muted = true;
    vid.play();
    return vid;
  });

  const setNormalize = useThreeJsLoader((state) => state.setNormalize);

  const [moldingType, setMoldingType] = useState({
    type: null,
    url: "",
  });

  const moldingRef = useRef();
  const aspectRatioRef = useRef();
  const imageRef = useRef();
  const moldingLandscapeRef = useRef(null);

  useEffect(() => {
    let imageWidth = gifRef.current.videoWidth;
    let imageHeight = gifRef.current.videoHeight;

    if (moldingLandscapeRef.current !== moldingType.url) {
      if (moldingType.type === "square") {
        aspectRatioRef.current = 1;
        imageRef.current.scale.set(1, 1, 1);
      } else if (moldingType.type === "landscape") {
        aspectRatioRef.current = imageWidth / imageHeight;
        imageRef.current.scale.set(1, 1 / aspectRatioRef.current, 1);
      } else {
        aspectRatioRef.current = imageHeight / imageWidth;
        imageRef.current.scale.set(1, aspectRatioRef.current, 1);
      }
    }
    moldingLandscapeRef.current = moldingType.url;
    setNormalize();
  }, [moldingType.url]);

  useEffect(() => {
    let imageWidth = gifRef.current.videoWidth;
    let imageHeight = gifRef.current.videoHeight;
    imageRef.current.material.alphaTest = 0.9;
    if (imageWidth === imageHeight) {
      aspectRatioRef.current = 1;
      setMoldingType({ type: "square", url: props.imgUrl });
    } else if (imageWidth > imageHeight) {
      setMoldingType({ type: "landscape", url: props.imgUrl });
    } else if (imageHeight > imageWidth) {
      setMoldingType({ type: "portrait", url: props.imgUrl });
    }
  }, [video, props.imgUrl, props.isGif]);

  return (
    <>
      <Plane args={[1, 1]} ref={imageRef}>
        <meshStandardMaterial side={THREE.DoubleSide}>
          <videoTexture attach="map" args={[video]} colorSpace="srgb" />
          <videoTexture attach="emissiveMap" args={[video]} colorSpace="srgb" />
        </meshStandardMaterial>
        <MoldingsManager
          ref={moldingRef}
          type={moldingType.type}
          molding={props.molding}
        />
      </Plane>
    </>
  );
};

export default AnimatedPainting;
